/**
 * Tries to parse an input against a regex to pull out a port, and then checks
 * that port for validity.
 *
 * Returns false if a port cannot be found or if the port is valid, true if parsed and invalid
 */
export function invalidPort(input: string, regex: RegExp): boolean {
  const matchedPort = input.match(regex)?.[1] ?? '';
  if (!matchedPort.length) {
    return false;
  }
  const parsedPort = Number(matchedPort);
  return Number.isNaN(parsedPort) || parsedPort < 1 || parsedPort > 65535;
}

/**
 * Tries to parse an input against a regex to pull out a port, and then checks
 * that port for validity.
 *
 * Returns false if a port cannot be found or if the port is valid, true if parsed and invalid
 */
export function invalidPortAllowZero(input: string, regex: RegExp): boolean {
  const matchedPort = input.match(regex)?.[1] ?? '';
  if (!matchedPort.length) {
    return false;
  }
  const parsedPort = Number(matchedPort);
  return Number.isNaN(parsedPort) || parsedPort < 0 || parsedPort > 65535;
}
